var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-item-block"},[_c('div',{staticClass:"disFlex"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"projectItem"},[_vm._v(" "+_vm._s(_vm.propName ? item.propName : item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }